import  * as api from  '@/api/kzActivity/test'
import * as TYPES from './type';

export default {
  // 课中活动测验
  async getClassRoomTestList({ commit, state }, { paramets, cb }) {
    const result = await api.reqClassRoomTestList(paramets)
    commit(TYPES.TEST_LIST, { result })
    cb && cb()
  },
  async postClassRoomTestAdd({ commit, state }, { paramets, cb, back }) {
    const result = await api.reqClassRoomTestAdd(paramets)
    commit(TYPES.TEST_INFO, { result, type:'add' })
    cb && cb()
    back && back()
  },
  async putClassRoomTestEdit({ commit, state }, { paramets, cb, back }) {
    const result = await api.reqClassRoomTestEdit(paramets)
    commit(TYPES.TEST_INFO, { result, type:'edit' })
    cb && cb()
    back && back()
  },
  async delClassRoomTestDel({ commit, state }, { paramets, cb }) {
    const result = await api.reqClassRoomTestDel(paramets)
    commit(TYPES.TEST_INFO, { result,  type:'del' })
    cb && cb()
  },
  async getClassRoomTestDetailById({ commit, state }, { paramets, cb }) {
    const result = await api.reqClassRoomTestDetailById(paramets)
    commit(TYPES.TEST_INFO, { result,  type:'detail' })
    cb && cb()
  },
  async delClassRoomTestDelBatch({ commit, state }, { paramets, cb }) {
    const result = await api.reqClassRoomTestDelBatch(paramets)
    commit(TYPES.TEST_INFO, { result,  type:'delBatch' })
    cb && cb()
  },
  async putClassRoomTestEdit({ commit, state }, { paramets, cb, back }) {
    const result = await api.reqClassRoomTestEdit(paramets)
    commit(TYPES.TEST_INFO, { result,  type:'edit' })
    cb && cb()
    back && back()
  },
  async getClassRoomTestListById({ commit, state }, { paramets, cb }) {
    const result = await api.reqClassRoomTestListById(paramets)
    commit(TYPES.TEST_INFO, { result,  type:'list' })
    cb && cb()
  },
}


// WEBPACK FOOTER //
// ./src/store/kzActivity/test/actions.js